"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "AdminTool_"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.86,18.89c-.73-1.09-2.7-1.87-6.14-3.19A5.13,5.13,0,0,0,15,14.32V12.84a4.3,4.3,0,0,0,1.49-3,2.38,2.38,0,0,0,.09-3c.52-1.4,1.19-3,.91-4.46C17.14.62,14.69,0,12.69,0c-1.56,0-3.44.4-4,1.48a1.93,1.93,0,0,0-1.38.74c-.87,1.19-.27,3,.15,4.6a2.4,2.4,0,0,0,.08,3,4.32,4.32,0,0,0,1.49,3H9v1.48A5.13,5.13,0,0,0,7.28,15.7C3.84,17,1.87,17.8,1.15,18.89.08,20.51,0,23.66,0,23.8s24,.26,24,0S23.92,20.51,22.86,18.89Z",
    fill: "#024965"
  }), ' ');
};

exports["default"] = _default;